export const DB_REF = {
  playerRequests: "player_requests",
  players: "players",
  practices: "practices",
  practiceData: "practice_data",
  teamCards: "team_cards",
  matchStats: "match_stats",
  currentSeason: "current_season",
  seasonStats: "season_stats",
};
